module.exports = __webpack_public_path__ + "static/media/goodnest_app4.306480a2.jpg";